import request from "../Config/axios";

// -----------------------------------------------------------
export const GetAll_Paging_Field_Api = async (params) => {
    const { data } = await request.post(
        `/Field/GetAll_Paging`,
        params
    );
    return data;
};
// -----------------------------------------------------------
export const GetAll_Field_Api = async (params) => {
    const { data } = await request.post(
        `/Field/GetAll`,
        params
    );
    return data;
};
// -----------------------------------------------------------
export const Delete_Field_Api = async (id) => {
    const { data } = await request.delete(
        `/Field/Delete/?id=` + id,
    );
    return data;
};
// -----------------------------------------------------------
export const Add_Field_Api = async (params) => {
    const { data } = await request.post(
        `/Field/Add`,
        params
    );
    return data;
};
// -----------------------------------------------------------
export const GetById_Field_Api = async (id) => {
    const { data } = await request.get(
        `/Field/GetById/?id=${id}`
    );
    return data;
};
// -----------------------------------------------------------
// -----------------------------------------------------------
export const Update_Field_Api = async (params) => {
    const { data } = await request.post(
        `/Field/Update`,
        params
    );
    return data;
};